





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































interface Foreigner {
	country: string;
	entryDate: string | Date;
	departureDate: string | Date;
	birthCountry: string;
	gender: string;
	birthday: string | Date;
}
interface accountData {
	accountBookId: number;
	code: null;
	fullcode: null;
	id: number;
	name: string;
	no: string;
	hidden: string;
	delIcon: boolean;
	dimDepartmentId?: number;
	assDepartmentName?: null | string;
	employType?: string;
	startDate?: string;
	endDate?: string;
	phone?: string;
	licenseNo?: string;
	licenseType?: string;
	checked?: boolean;
	birthCountry?: string;
	country?: string;
	gender?: string;
	departureDate?: string | Date;
	birthday?: string | Date;
	entryDate?: string | Date;
	isSix?: string | boolean;
	isBaseDeduction?: string | boolean;
}

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ElDatePicker } from "element-ui/types/date-picker";
import { ElSelect } from "element-ui/types/select";
import { mapGetters } from "vuex";
import SideNavVue from "../components/SideNav.vue";
import ForeignersVue from "../components/AssistingAccount/Foreigners.vue";
import StaffImportVue from "../components/AssistingAccount/StaffImport.vue";
import idTypeList from "../data/idTypeList";
import AssistDepartment from "../data/AssistDepartment";
import MultiEditorVue from "../components/AssistingAccount/MultiEditor.vue";
import version from "@/version";
import DimInventoryTypeList from "@/data/DimInventoryTypeList";
import AccountingSystem from "@/data/AccountingSystem";

export interface DatePicker extends ElDatePicker {
	handleClose(): void;
}

@Component({
	...mapGetters(["accountBook"]),
	components: {
		"side-nav": SideNavVue,
		foreigners: ForeignersVue,
		"staff-import": StaffImportVue,
		"multi-edit": MultiEditorVue
	},
})
export default class AssistingAccount extends Vue {
	@Prop({ type: Boolean, default: false })
	isPayRoll!: boolean;

	@Prop({ type: Object, })
	payData!: any;

	query: string = "";
	typeTop: string = "96";
	payName: string = "员工信息"
	// 受雇类型
	employeeTypeList: DataTable.DropItem[] = [
		{ id: "0", text: "雇员" },
		{ id: "1", text: "其他" },
	];
	typeList = idTypeList; //部门选择
	accountTypeName: string = "项目";
	accountListName: string = "dimItemList";
	dimItemShow: boolean = true; //项目 部门 员工
	assStaffShow: boolean = this.isPayRoll ? true : false; // for staff
	assUserShow: boolean = false; //客户 供应商
	assInvShow: boolean = false; //存货
	tableData: accountData[] = [];
	//最后一行第一个input
	addCodeInput: string = ""; //编码
	newItemName: string = ""; //名称
	newItemContact: string = ""; //联系人
	newItemPhone: string = ""; //电话
	newItemTaxNo: string = ""; //税号
	newItembankAccount: string = ""; //银行账号
	measureUnit: string = ""; //计量单位
	addaddField: string = "dim/item";
	modifyField: string = "dim/item"; //修改field
	employeeType: string = "0"; //雇员类型
	newHireDate: string | Date = ""; //任职受雇日期
	newQuiteDate: string | Date = ""; //离职日期

	newItemLicenseType: string = "1";
	newLicenseType: string | null = null; 
	newItemLicenseNo: string = "";
	newItemdimDepartmentId: string = "";

	inventoryTypeList = DimInventoryTypeList;
	// 下载
	downLoad() {
		let url = "export/dim/account";
		this.$store.dispatch("toggleDownload", true);
		this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}${url}?accountBookId=${this.$store.state.accountBook.id}&dimAccountTypeName=${this.accountTypeName}&version=${version}&token=${this.$store.state.account.token}&query=${this.query}&hidden=${this.hidden}&employType=${this.employType}&employStatus=${this.employStatus}`);
	}
	// 侧边栏切换
	accountUrl: string = "dim/item";
	payItem(item: AssistSide) {
		if (item.text === "工资表") {
			this.$emit("close")
		}
	}
	placeholder:string = "可输入项目名称"
	accItem(item: AssistSide) {
		this.resetFilter()
		this.page = 1;
		this.accountTypeName = item.text;
		this.accountListName = item.listName;
		this.accountUrl = item.field;
		this.addaddField = this.modifyField = item.field;
		
		this.query = ""
		if(item.text === "客户") this.placeholder = "可输入客户名称"
		else if(item.text === "项目") this.placeholder = "可输入项目名称"
		else if(item.text === "供应商") this.placeholder = "可输入供应商名称"
		else if(item.text === "部门") this.placeholder = "可输入部门名称"
		else if(item.text === "存货") this.placeholder = "可输入存货名称"
		else if(item.text === "员工") this.placeholder = "可输入员工名称，证件号码"

		if (item.statusCode === "0") {
			this.dimItemShow = true;
			this.assUserShow = false;
			this.assInvShow = false;
			if (item.text === "员工") this.assStaffShow = true;
			else this.assStaffShow = false;
			if (item.text === "部门") this.assDepartShow = true;
			else this.assDepartShow = false;
		} else if (item.statusCode === "1") {
			this.dimItemShow = false;
			this.assUserShow = true;
			this.assInvShow = false;
			this.assStaffShow = false;
			this.assDepartShow = false;
		} else {
			this.dimItemShow = false;
			this.assUserShow = false;
			this.assInvShow = true;
			this.assStaffShow = false;
			this.assDepartShow = false;
		}
		this.multiOn = false;
		this.fetchData(this.clearData);
		if (
			this.$store.state.accountBook.accountingSystem ===
			AccountingSystem.npo
		) {
			this.departments = ["管理部门", "销售部门", "行政部门"];
		} else {
			this.departments = AssistDepartment;
		}
	}
	// 分页
	size: number = 14;
	page: number = 1;
	totalElements: number = 0;
	handleCurrentChange(val: number) {
		this.page = val;
		this.fetchData(this.clearData);
	}
	changeSize(size: number) {
        this.size = size;
        this.fetchData(this.clearData);
    }
	filterVisible: boolean = false;
	hidden: string = ""
	ztList: DataTable.DropItem[] = [
		{ id: "y", text: "未启用" },
		{ id: "n", text: "启用" },
		{ id: "", text: "全部" },
	]
	employType: string = "2";
	sgList: DataTable.DropItem[] = [
		{ id: "0", text: "雇员" },
		{ id: "1", text: "其他" },
		{ id: "2", text: "全部" },
	]
	employStatus: string = "2";
	ryList: DataTable.DropItem[] = [
		{ id: "0", text: "在职" },
		{ id: "1", text: "离职" },
		{ id: "2", text: "全部" },
	]
	resetFilter() {
		this.hidden = ""
		this.employType = "2"
		this.employStatus = "2"
		// this.fetchData();
		// this.filterVisible = false;
	}
	confirmFilter() {
		this.page = 1;
		this.fetchData();
		this.filterVisible = false;
	}
	payChoose() {
		this.hidden = this.payData.hidden
		this.employType = this.payData.employType
		this.employStatus = this.payData.employStatus
		this.page = 1
		this.fetchData();
	}
	mounted() {
		if (this.isPayRoll) {
			this.accItem({
				text: "员工",
				listName: "dimEmployeeList",
				statusCode: "0",
				field: "dim/employee",
			});
			this.typeTop = "40";
			this.payName = "员工信息"
			this.placeholder="可输员工名称,证件号码 "
		}
		else this.fetchData(this.clearData);
	}
	totalPage: number = 1;
	changeFetch() {
		this.page = 1;
		this.fetchData();
	}
	// 初始化获取数据
	fetchData(cb?: Function, val?: string) {
		if (val === "") this.query = "";
		if (val) this.query = val;
		console.log(this.accountUrl)
		Vue.axios
			.get(
				this.accountUrl +
				`/find?accountBookId=${this.$store.state.accountBook.id
				}&page=${this.page - 1}&size=${this.size}&query=${this.query
				}&hidden=${this.hidden}&employType=${this.employType}&employStatus=${this.employStatus}`
			)
			.then((res) => {
				let tempData = res.data.content;
				for (var i = 0; i < tempData.length; i++) {
					if (this.accountTypeName === "员工") {
						if (tempData[i].startDate)
							tempData[i].startDate = new Date(
								tempData[i].startDate.substring(0, 4) +
								"-" +
								tempData[i].startDate.substring(4, 6) +
								"-" +
								tempData[i].startDate.substring(6)
							);
						if (tempData[i].endDate)
							tempData[i].endDate = new Date(
								tempData[i].endDate.substring(0, 4) +
								"-" +
								tempData[i].endDate.substring(4, 6) +
								"-" +
								tempData[i].endDate.substring(6)
							);
						if (tempData[i].isSix) {
							tempData[i].isSix = +tempData[i].isSix === 0 ? false : true;
						}
						if (tempData[i].isBaseDeduction) {
							tempData[i].isBaseDeduction = +tempData[i].isBaseDeduction === 0 ? false : true;
						}
					}
					tempData[i].delIcon = false;
					tempData[i].hidden =
						tempData[i].hidden == "y" ? false : true;
				}
				res.data.content.forEach((v: any) => {
					v.checked = false;
				});
				this.tableData = res.data.content;
				this.totalElements = res.data.totalElements;
				if (this.accountTypeName === "员工") {
					this.getDepartList();
				}
				this.totalPage = res.data.totalPages;
				if (cb) cb();
				this.newForeigner = {
					country: "",
					entryDate: "",
					departureDate: "",
					birthCountry: "",
					gender: null,
					declareType: null,
				};
			});
	}
	// 获取员工下拉选择
	departList: accountData[] = []; //员工 的部门列表
	getDepartList() {
		Vue.axios
			.post(`dim/account/find`, {
				accountBookId: this.$store.state.accountBook.id,
				dimAccountType: "部门",
			})
			.then((res) => {
				this.departList = res.data.dimDepartmentList;
			});
	}

	// 展示隐藏删除图标
	showIcon(data: accountData) {
		data.delIcon = true;
	}
	hiddenIcon(data: accountData) {
		data.delIcon = false;
	}

	changeSelect(
		data: accountData,
		ref?: string,
		noFetch?: boolean,
		newItemLicenseType?: number
	) {
		if (data != null) {
			if (!noFetch) this.modifyData(data);
			if (ref) {
				(<any>this.$refs[ref])[0].focus();
			}
		} else {
			if (!noFetch) this.addData();
			if (newItemLicenseType) {
				if (newItemLicenseType != 1) {
					this.foreignerInfo = this.newForeigner;
					this.isAdd = true;
					this.isOther = +this.employeeType === 1;
					this.newLicenseType = this.newItemLicenseType
					this.showForeigners = true;
				}
			}
			if (ref) (<any>this.$refs[ref]).focus();
		}
	}
	changeLicense(newItemLicenseType?: number) {
		if (newItemLicenseType) {
			if (newItemLicenseType != 1) {
				this.isAdd = true;
				this.foreignerInfo = this.newForeigner;
				this.newLicenseType = this.newItemLicenseType
				this.showForeigners = true;
			}
		}
	}
	//进入焦点  显示编码内容
	editCode(el: any) {
		el.currentTarget.select();
		el.currentTarget.style.backgroundColor = "white";
		this.makeCode();
	}
	//自动生成编码
	makeCode() {
		if (this.addCodeInput != "") return;
		if (this.tableData.length > 0) {
			let highest = this.tableData[0].no;
			for (let i = 0; i < this.tableData.length; i++) {
				if (i !== 0) {
					if (
						+this.tableData[i].no > +this.tableData[i - 1].no &&
						+this.tableData[i].no > +highest
					) {
						highest = this.tableData[i].no;
					}
				}
			}
			let num = (+highest + 1).toString();
			const numLength = num.length;
			for (let i = 0; i < 4 - numLength; i++) {
				num = "0" + num;
			}
			if (this.addCodeInput !== null) this.addCodeInput = num;
		}
		if (this.tableData.length == 0) {
			this.addCodeInput = "0001";
		}
		// if (this.addCodeInput != "") return;
		// if (this.tableData.length == 0) {
		//     this.addCodeInput = "0001";
		// } else {
		//     let newNo = +this.tableData[this.tableData.length - 1].no + 1;
		//     this.addCodeInput = ("0000" + newNo).substr(-4);
		// }
	}
	// focus input
	// 光标进入时记录下value值
	recoderValue: string = "";
	curIndex: number = -1;
	editSomething(el: any, data?: accountData, select?: any, index?: number, name?: string) {
		if (name === "newItemPhone") {
			this.$message.warning("号码不应重复")
		}
		if (select) el.currentTarget.select();
		if (data === undefined) this.makeCode();
		this.recoderValue = el.currentTarget.value;
		el.currentTarget.style.backgroundColor = "white";
		if (index) this.curIndex = index;
	}
	// modify data 光标离开
	modifySomething(el: any, data: accountData, num?: any, ref?: string) {
		if (el) {
			let target: any =
				el.currentTarget != null ? el.currentTarget : el.target;
			if (el.target || el.currentTarget) {
				target.style.backgroundColor = "";
				if (target.value == this.recoderValue) {
					return;
				}
				if (num && /\D/.test(target.value)) {
					this.$message.warning("编码格式不对！");
					data.no = this.recoderValue;
					return;
				}
			}
		}
		if (data.no === "") {
			data.no = this.recoderValue;
			return;
		}
		if (data.name === "") {
			data.name = this.recoderValue;
			return;
		}
		this.modifyData(data);
	}
	//修改 保存 内容
	modifyData(data: accountData) {
		if (data.no != "" && data.name != "") {
			if (this.assStaffShow) {
				if (data.licenseType) {
					if (data.licenseType != "1") {
						let notNull = false
						if (!this.isOther) {
							notNull = this.$utils.notNull([
								data.country,
								data.entryDate,
								data.departureDate,
								data.birthCountry,
								data.birthday
							]);
						} else {
							notNull = this.$utils.notNull([
								data.country,
								data.birthCountry,
								data.birthday
							]);
						}
						if (!notNull) {
							this.$message.warning("请完整填写外籍人员信息!");
							return;
						}
					}
				}
				if (data.hidden) {
					if (
						data.licenseType === "" ||
						data.licenseType === null ||
						data.licenseNo === "" ||
						data.licenseNo === null
					) {
						this.$message.warning("证件类型和号码不能为空!");
						return;
					}
					if (data.employType === "0") {
						if (
							data.startDate === "" ||
							data.startDate === null ||
							data.phone === "" ||
							data.phone === null
						) {
							this.$message.warning(
								"手机号,雇员受雇日期不能为空!"
							);
							return;
						}
					}
				} else {
					if (
						data.licenseType === "" ||
						data.licenseType === null ||
						data.licenseNo === "" ||
						data.licenseNo === null
					) {
						this.$message.warning("证件类型和号码不能为空!");
						return;
					}
					if (data.employType === "0" || data.employType === "1") {
						if (data.phone === "" || data.phone === null) {
							this.$message.warning("手机号不能为空!");
							return;
						}
					}
					if (
						(data.startDate === "" ||
							data.startDate === null ||
							data.endDate === "" ||
							data.endDate === null) &&
						data.employType === "0"
					) {
						this.$message.warning(
							"离职员工的受雇日期和离职日期不能为空!"
						);
						return;
					}
				}
				if (!this.testNo(data, 1)) return;
			}
			data.no = ("0000" + data.no).substr(-4);
			if (data.startDate && data.startDate != null)
				data.startDate = this.$utils.simpleDateFormat(
					new Date(data.startDate),
					"d"
				);
			if (data.endDate && data.endDate != null)
				data.endDate = this.$utils.simpleDateFormat(
					new Date(data.endDate),
					"d"
				);
			if (data.hidden) data.hidden = "n";
			else data.hidden = "y";
			if (data.isSix) {
				data.isSix = "1"
			} else data.isSix = "0"
			if (data.isBaseDeduction) {
				data.isBaseDeduction = "1"
			} else data.isBaseDeduction = "0"
			let obj = Object.assign(
				{ accountBookId: this.$store.state.accountBook.id },
				data
			);
			Vue.axios({
				url: this.modifyField + "/modify",
				method: "POST",
				data: obj,
			}).then((res) => {
				this.fetchData();
			}).catch((res) => {
				if (this.assStaffShow) this.fetchData()
			});
		}
	}

	// clear last tr 新增后清除新增行的数据
	clearData() {
		this.addCodeInput = "";
		this.newItemName = "";
		this.newItemContact = "";
		this.newItemPhone = "";
		this.newItemTaxNo = "";
		this.newItembankAccount = "";
		this.measureUnit = "";
		this.newItemLicenseType = "1";
		this.newItemLicenseNo = "";
		this.newItemdimDepartmentId = "";
		this.newHireDate = "";
		this.newQuiteDate = "";
		this.newIsSix = false;
		this.newIsBaseDeduction = true;
		this.inventoryType = null;
		this.$forceUpdate();
		(<HTMLInputElement>this.$refs.newStaffInput).focus();
	}
	// del data 删除行
	deleteItem(data: accountData) {
		this.$confirm("亲，确定删除 " + data.name + " 吗?", "温馨提示").then(
			(action: any) => {
				if (action === "confirm") {
					Vue.axios
						.post(
							`dim/account/delete?ids=${data.id}&accountBookId=${this.$store.state.accountBook.id}&dimAccountType=${this.accountTypeName}`,
							{ nothing: null }
						)
						.then((res) => {
							if (
								this.page ===
								Math.ceil(this.totalElements / this.size)
							) {
								if (
									this.page != 1 &&
									this.tableData.length === 1
								)
									this.page = this.page - 1;
							}
							if(res.data.message) {
								this.$message.warning(res.data.message)
							}
							this.fetchData();
						});
				}
			}
		);
	}
	// focus input
	focusTax(el: FocusEvent, select: any, index: number) {
		let target = <HTMLInputElement>el.currentTarget;
		if (select) target.select();
		if (index === -1) this.makeCode();
		this.recoderValue = target.value;
		target.style.backgroundColor = "white";
		this.curIndex = index;
	}
	// 离开焦点判断是新增还是修改
	blurTax(e: any, data: accountData | number) {
		if (data === -1) {
			this.addSomething(e);
		} else {
			this.$nextTick(() => {
				this.modifySomething(e, <accountData>data);
			});
		}
	}

	// add data  新增离开焦点（是否新增数据）
	addSomething(el: any, ref?: any, noCheck?: boolean) {
		if (
			this.$utils.canControl() &&
			(this.page === this.totalPage || this.totalPage === 0) &&
			this.newItemName != "" &&
			(el.target &&
				el.target.className !== "el-checkbox__original")
		) {
			if (el.currentTarget) {
				el.currentTarget.style.backgroundColor = "";
			}
			let focusLast = false;
			let inputs: any = document.querySelectorAll(".addTr input");
			if (
				this.$refs.departSelect &&
				this.$refs.newStartDate &&
				this.$refs.newEndDate
			) {
				(<ElSelect>this.$refs.departSelect).blur();
				(<DatePicker>this.$refs.newStartDate).handleClose();
				(<DatePicker>this.$refs.newEndDate).handleClose();
			}
			setTimeout(() => {
				for (let i = 0; i < inputs.length - 1; i++) {
					if (inputs[i] == document.activeElement) {
						focusLast = true;
						break;
					}
				}
				if (focusLast != true || noCheck) {
					if (this.assStaffShow) {
						if (
							this.newItemLicenseType === "" ||
							this.newItemLicenseNo === ""
						) {
							this.$message.warning("证件类型、号码不能为空!");
							return;
						}
						if (this.employeeType === "0") {
							if (
								this.newHireDate === null ||
								this.newHireDate === "" ||
								this.newItemPhone === "" ||
								this.newItemPhone === null
							) {
								this.$message.warning(
									"手机号,雇员的受雇日期不能为空!"
								);
								return;
							}
						}
						if (!this.testNo(this, 0)) return;
					}
					if (this.addCodeInput === "" || this.newItemName === "") {
						this.$message.warning("编码、名称不能为空！");
						return;
					}
					let notNull;
					if (!this.isOther) {
						notNull = this.$utils.notNull([
							this.newForeigner.country,
							this.newForeigner.entryDate,
							this.newForeigner.departureDate,
							this.newForeigner.birthCountry,
							this.newForeigner.birthday,
						]);
					} else {
						notNull = this.$utils.notNull([
							this.newForeigner.country,
							this.newForeigner.birthCountry,
							this.newForeigner.birthday,
						]);
					}
					if (this.assStaffShow) {
						if (this.newItemLicenseType != "1") {
							if (!notNull) {
								this.$message.warning(
									"请填写完整的境外人员信息"
								);
								return;
							}
						} else {
							if (
								!this.$utils.isCorrectAge(this.newItemLicenseNo)
							) {
								this.$message(
									"亲，新增员工的年龄未满18岁或大于60岁"
								);
							}
						}
					}
					this.addData();
				}
			}, 100);
		} else return;
	}

	// 新增行的 “按6万扣除”
	newIsSix = false;
	newIsBaseDeduction = true;

	// 新增行的 “商品类型”
	inventoryType: string | null = null;
	// 新增数据
	addData() {
		Vue.axios
			.post(this.addaddField + `/add`, {
				accountBookId: this.$store.state.accountBook.id,
				no: ("0000" + this.addCodeInput).substr(-4),
				name: this.newItemName,
				contact: this.newItemContact,
				phone: this.newItemPhone,
				taxNo: this.newItemTaxNo,
				bankAccount: this.newItembankAccount,
				measureUnit:
					this.measureUnit.trim() === ""
						? null
						: this.measureUnit.trim(),
				licenseType: this.newItemLicenseType,
				licenseNo: this.newItemLicenseNo,
				dimDepartmentId: this.newItemdimDepartmentId,
				startDate: this.$utils.notNull([this.newHireDate])
					? this.$utils.simpleDateFormat(<Date>this.newHireDate, "d")
					: "",
				endDate: this.$utils.notNull([this.newQuiteDate])
					? this.$utils.simpleDateFormat(<Date>this.newQuiteDate, "d")
					: "",
				employType: this.employeeType,
				hidden: "n",
				country: this.newForeigner.country,
				gender: this.newForeigner.gender,
				birthday: this.newForeigner.birthday,
				entryDate: this.newForeigner.entryDate,
				departureDate: this.newForeigner.departureDate,
				birthCountry: this.newForeigner.birthCountry,
				declareType: this.newForeigner.declareType,
				isSix: this.newIsSix ? "1" : "0",
				isBaseDeduction: this.newIsBaseDeduction ? "1" : "0",
				type: this.inventoryType
			})
			.then(() => {
				if (this.tableData.length === 14) {
					this.totalElements = this.totalElements + 1;
					this.page = this.page + 1;
					this.handleCurrentChange(this.page);
				} else {
					this.fetchData(this.clearData);
				}
				this.newForeigner = {
					country: "",
					entryDate: "",
					departureDate: "",
					birthCountry: "",
					gender: null,
					declareType: null,
				};
			});
	}

	// 添加身份证验证
	testNo(data: any, type: number) {
		let licenseType, licenseNo;
		if (type === 0) {
			//新增
			licenseType = data.newItemLicenseType;
			licenseNo = data.newItemLicenseNo;
		} else {
			licenseType = data.licenseType;
			licenseNo = data.licenseNo;
		}
		const reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
		if (licenseType === "1") {
			if (!reg.test(licenseNo)) {
				this.$message.warning("身份证格式不正确");
				return false;
			}
			return true;
		}
		return true;
	}

	// 部门下拉
	departments = AssistDepartment;
	assDepartShow: boolean = false;
	//
	dateClick(e: MouseEvent) {
		e.stopPropagation();
	}

	// 全选
	checkedAll: boolean = false;
	changeAll(val: boolean) {
		this.checkedAll = val;
		for (let i = 0; i < this.tableData.length; i++) {
			this.$set(this.tableData[i], "checked", val);
		}
	}
	// 监听全选
	@Watch("tableData", { deep: true })
	checkedChange(val: accountData[]) {
		let all = true;
		for (let i = 0; i < val.length; i++) {
			if (!val[i].checked) {
				all = false;
				break;
			}
		}
		this.checkedAll = all;
	}
	// 批量删除
	delAll() {
		let vouchers: accountData[] = [];
		this.tableData.forEach((v) => {
			if (v.checked) vouchers.push(v);
		});
		let checkedId: number[] = [];
		vouchers.forEach((v) => {
			checkedId.push(v.id);
		});
		let id = "";
		if (vouchers.length > 0) {
			if (vouchers.length === 1) {
				id = checkedId.join("");
			} else id = checkedId.join(",");
			this.$msgbox({
				message: `您共选了 ${checkedId.length} 条辅助核算项，是否确认删除？`,
				title: "温馨提示",
				confirmButtonText: "确定",
				showCancelButton: true,
			}).then((action: any) => {
				if (action == "confirm") {
					Vue.axios
						.post(
							`dim/account/delete?ids=${id}&accountBookId=${this.$store.state.accountBook.id}&dimAccountType=${this.accountTypeName}`,
							{ nothing: "" }
						)
						.then((res) => {
							if (
								this.page ===
								Math.ceil(this.totalElements / this.size)
							) {
								if (
									this.page != 1 &&
									this.tableData.length === 1
								)
									this.page = this.page - 1;
							}
							if(res.data.message) {
								this.$message.warning(res.data.message)
							}
							this.checkedAll = false;
							this.fetchData();
						});
				}
			});
		} else {
			this.$message.warning("请勾选");
		}
	}
	// 非居民身份证
	foreignerInfo: any = {};
	newForeigner: any = {};
	showForeigners: boolean = false;
	isAdd: boolean = true;
	foreignerSuccess(val: any, index: number) {
		if (index === 0) {
			this.newForeigner = val;
			let inputs: any = document.querySelector(".foreFocus input");
			inputs.focus();
		} else this.modifyData(val);
		this.showForeigners = false;
	}
	// 修改外籍
	modifyFore(row: any) {
		if (row) {
			this.foreignerInfo = row;
		}
		this.isAdd = false;
		this.isOther = row.employType === "1";
		this.newLicenseType = row.licenseType
		this.showForeigners = true;
	}
	// 关闭外籍信息清空
	closeFore() {
		this.showForeigners = false;
	}

	// 外籍信息中，用来判断当前员工是否为非雇员
	isOther = false;
	// 导入员工信息
	isImport: boolean = false;
	closeImport() {
		this.isImport = false;
	}
	successImport() {
		this.fetchData();
		this.isImport = false;
	}
	showImport() {
		this.isImport = true;
	}

	// 批量修改员工信息
	multiOn = false;
	get hasChecked() {
		for (let i = 0; i < this.tableData.length; i++) {
			if (this.tableData[i].checked) {
				return true;
			}
		}
		return false;
	}

	multiVisible = false;
	checkedNumber: Assist.AccountData[] = [];
	clickMulti() {
		let n: Assist.AccountData[] = [];
		for (let i = 0; i < this.tableData.length; i++) {
			if (this.tableData[i].checked) n.push(this.tableData[i]);
		}
		this.checkedNumber = n;
		this.multiVisible = true;
	}
	saveMulti() {
		this.multiVisible = false;
		this.multiOn = false;
		this.fetchData();
	}
	closeMulti() {
		this.multiVisible = false;
	}
	cancelMulti() {
		this.multiOn = false;
		this.delOn = false;
	}

	// 点击计量单位阻止冒泡
	focusUnit(e: FocusEvent) {
		(<HTMLInputElement>e.target).focus();
	}

	delOn = false;
	clickDel() {
		this.multiOn = true;
		this.delOn = true;
	}
}
